import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" CPU Run Time & CPU Saved Time by Build Cache ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Learn More ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "uis uis-arrow-right mt-[4px] !mr-0" }, null, -1)

import { IncrediButton, IncrediCard, IncrediChartBar } from 'incredi-ui';
import { computed } from 'vue';
import dashboardNoData from '@/views/dashboard/components/dashboard-no-data.vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { dataZoomSliderOff, openLearnMoreLink } from '@/views/dashboard/dashboard.charts.utils';
import DashboardChartTitle from '@/views/dashboard/components/dashboard-chart-title.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'build-cache-cpu-run-time-and-saved-time-chart',
  props: {
    noData: null,
    chartOptions: null
  },
  setup(__props: any) {

const props = __props as {
  noData?: 'buildCacheLicenseeNeeded' | 'noDataFound';
  chartOptions: InstanceType<typeof IncrediChartBar>['$props'];
}


const chartProps = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { options, ...rest } = props.chartOptions;

  return rest;
});

const tooltip = [
  {
    description: ['The total CPU run time of all machines assisting or running a build,', 'compared with the CPU run time that was saved by accessing', 'the Build Cache.'],
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediCard), { class: "relative p-[16px] h-full !shadow-none border border-Border/border_natural" }, {
        default: _withCtx(() => [
          _createVNode(DashboardChartTitle, {
            absolute: "",
            tooltip: tooltip
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          (__props.noData === 'noDataFound')
            ? (_openBlock(), _createBlock(dashboardNoData, {
                key: 0,
                class: "py-[52px] mt-[16px]",
                icon: "no_data",
                "data-testid": "cpu-runtime-savetime-build-cache-nodata",
                card: false,
                title: "No Cache Cores Used"
              }))
            : (__props.noData === 'buildCacheLicenseeNeeded')
              ? (_openBlock(), _createBlock(dashboardNoData, {
                  key: 1,
                  class: "pt-[32px] max-w-[385px] text-center mx-auto",
                  icon: "no_data",
                  card: false,
                  title: "Upgrade to Build Cache",
                  subtitle: "Build Cache empowers your Incredibuild Platform even more",
                  "subtitle-additional": "by reusing previous builds and only building what changed"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IncrediButton), {
                      size: "small",
                      class: "mt-[6px]",
                      onClick: _unref(openLearnMoreLink)
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2,
                        _hoisted_3
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(IncrediChartBar), _mergeProps({
                  key: 2,
                  height: "284px",
                  options: {
          dataZoom: _unref(dataZoomSliderOff),
          ...(__props.chartOptions.options || {}),
        }
                }, _unref(chartProps)), null, 16, ["options"]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})